import { Action } from '@op/opds.opux';
import styles from './InfoSection.module.scss';
import i18n from 'i18n';

const AccessibilityInfo = () => {
  return (
    <div
      className={styles.accessibilityInfoSection}
      data-testid='accessbility-info-section'>
      <p className={styles.infoText} data-testid='accessibility-info-text'>
        {i18n.t('accessibilityInfoSection.accessibilityInfoText')}
      </p>
      <Action
        data-testid='accessibility-info-link'
        external
        href={i18n.t('accessibilityInfoSection.ACCESSIBILITY_INFO_LINK')}
        className={styles.link}>
        {i18n.t('accessibilityInfoSection.linkText')}
      </Action>
    </div>
  );
};

export default AccessibilityInfo;
